import React from "react";
import PropTypes from "prop-types";

import SectionStreamWrapper from "stream/containers/SectionStreamWrapper";
import SmarterFasterHeader from "stream/components/SmarterFasterHeader";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";

import { DEFAULT_CARD_HEIGHT } from "config/constants";

export default function SmarterFasterSectionStream(props) {
  return (
    <SectionStreamWrapper {...props} slug={props.match.params.section}>
      {({ streamParams }) => {
        return (
          <>
            <SmarterFasterHeader />
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
              onlyShowTitleForA11y={true}
            />
          </>
        );
      }}
    </SectionStreamWrapper>
  );
}

SmarterFasterSectionStream.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      section: PropTypes.string.isRequired,
    }),
  }),
};
